<template>
  <div v-if="show" class="vs-select d-flex flex-fill" :class="{'multiple': header.multiple}">
    <div v-if="mode === 'view'" class="d-flex flex-fill">
      <div
        v-if="selectedValue !== undefined && selectedValue !== null && Array.isArray(selectedValue)"
      >
        <span
          v-for="(item,index) in selectedValue"
          :key="index"
          class="badge badge-warning mb-1"
        >{{ item[header.label] }}</span>
      </div>
      <div
        v-else-if="selectedValue !== undefined && selectedValue !== null && !Array.isArray(selectedValue)"
      >
        <span class="badge badge-warning mb-1">{{ selectedValue[header.label] }}</span>
      </div>
    </div>
    <div v-if="mode === 'edit' || mode === 'create'" class="d-flex flex-fill">
      <v-select
        :class="{'no-border-radius': header.noBorderRadius}"
        dir="rtl"
        :label="header.label"
        :options="selectablesList"
        :multiple="header.multiple"
        v-model="selectedValue"
      >
        <span slot="no-options">موردی برای نمایش وجود ندارد.</span>
      </v-select>
    </div>
  </div>
</template>

<script>
  import vSelect from "vue-select";
  import BaseService from "./api/BaseService.js";
  import EventBus from "./bus.js";

  export default {
    name: "vs-select",
    props: {
      data: null,
      header: {
        default() {
          return {
            label: "title",
            multiple: false,
            noBorderRadius: false
          };
        },
        type: Object
      },
      headerKey: {
        default: "",
        type: String
      },
      mode: {
        default: "view",
        type: String
      },
      selectedVal: {
        default() {
          return null;
        }
      },
      interval: null,
      options: {
        default() {
          return null;
        }
      },
      isHeader: {
        default: false,
        type: Boolean
      }
    },
    mounted() {

      EventBus.$on("onResetHeaderFormsValue", () => {
        if (this.mode !== "view") {
          this.selectedValue = null;
        }
      });

      if (
        this.options != null &&
        this.header &&
        this.header.listParams &&
        (this.header.listParams.requestURI || this.header.listParams.selectItems)
      ) {
        if (this.header.listParams.selectItems) {
          this.selectablesList = this.header.listParams.selectItems;
          this.selectablesList = this.header.listParams.selectItems.filter(d => {
            return d[this.header.label] !== null;
          });
          if (!this.isHeader) {
            this.selectedValue = JSON.parse(JSON.stringify(this.data));
          }
        }
        else {
          new BaseService(null, this.header.listParams.requestURI)
            .getRequest()
            .then(response => {
              this.selectablesList = response.data.data || response.data;
              this.selectablesList = this.selectablesList.filter(d => {
                return d[this.header.label] !== null;
              });
              if (!this.isHeader) {
                this.selectedValue = JSON.parse(JSON.stringify(this.data));
              }
            });
        }
      } else if (this.options == null) {

        if (this.data || this.data !== undefined) {
          this.selectablesList = JSON.parse(JSON.stringify(this.data));
        }
      }
      if (this.data !== null && this.data !== undefined) {
        if (this.data.data) {
          this.selectablesList = JSON.parse(JSON.stringify(this.data.data));
        }
      }
    },
    data() {
      return {
        selectedValue: null,
        selectablesList: [],
        show: true,
      };
    },
    components: {
      vSelect
    },
    computed: {
      _selectedValue() {
        if (this.mode !== "create") {
          if (this.selectedVal) {
            this.selectedValue = this.selectedVal;
          }
          return this.selectedValue;
        }
      }
    },
    watch: {
      'header.listParams.requestURI': {
        handler(val) {
          if (val === undefined || val === null) {
            return;
          }
          new BaseService(null, val)
            .getRequest()
            .then(response => {
              this.selectablesList = response.data.data || response.data;
              this.selectablesList = this.selectablesList.filter(d => {
                return d[this.header.label] !== null;
              });
              if (!this.isHeader) {
                this.selectedValue = JSON.parse(JSON.stringify(this.data));
              }
            });
        },
        deep: true
      },
      _selectedValue(val) {
        this.selectedValue = val;
      },
      selectedValue(val) {
        this.$emit("onChange", val);
        this.$emit("dataChanged", this.headerKey, val);
      },
      // selectedVal(val) {
      //   this.selectedValue = val;
      // },
      data(val) {
        this.selectablesList = val;

        if (!this.isHeader) {
          this.selectedValue = JSON.parse(JSON.stringify(this.data));
        }
      }
    }
  };
</script>

<style scoped>
  .no-border-radius {
    border-radius: 0;
  }

  .dropdown {
    display: flex;
    flex: 1;
  }
</style>
